import { createInertiaApp } from "@inertiajs/react"
import { createRoot } from "react-dom/client"
import "../../assets/stylesheets/application.css"

const pages = import.meta.glob("../pages/**/*.tsx", { eager: true })

createInertiaApp({
  title: (title) => (title ? `${title} - Pose` : "Pose"),
  resolve: (name) => {
    const key = `../pages/${name}.tsx`
    const page = pages[key]
    if (!page) {
      console.error(`Page not found: ${name}`, "Available:", Object.keys(pages))
    }
    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
